module.exports = __webpack_public_path__ + "img/IMAGE8.eb29d146.jpg";